import { Link, useNavigate } from "react-router-dom";
import ellowLogo from "../../assets/images/ellow-logo.svg";
import ellowLogoIcon from "../../assets/images/ellow-logo-icon.svg";
import { Icon } from "@iconify/react";
import Styles from "./styles.module.scss";
import Button from "../../components/button";
import classnames from "classnames";
import { Auth } from "aws-amplify";
import { LOGIN } from "../../navigation/CONSTANTS";
import { useEffect, useState } from "react";
import ConfirmationModal from "../../modal/confirmation/confirmationModal";
import mixpanelData from "../../utils/mixpanel";
import mixpanel from "mixpanel-browser";


interface Props {
  menu?: { icon: string, title: string, url: string, active: boolean }[],
  openresource?: string,
  opentimesheet?: string,
  userName?: string,
}



const SideMenu: React.FC<Props> = ({
  menu = [],
  openresource,
  opentimesheet,
  userName
}) => {

  const [fullname, setFullName] = useState<any>(userName)
  const [logoutModal, setLogoutModal] = useState<boolean>(false)

  const navigate = useNavigate();

  useEffect(() => {

    const fullName = localStorage.getItem('Name')

    setFullName(fullName)

    if (openresource) {
      setShow((prev => !prev))
    }
    if (opentimesheet) {
      setShow((prev => !prev))
    }
  }, [userName])

  const logout = () => {
    setLogoutModal(true)
}

  async function onLogout() {
      try {
        mixpanelData('New TG - SignOut', {
          'Source': 'Recruiter successfully signout from the system',
          'Recruiter name': localStorage.getItem('Name'),
          'Recruiter email': localStorage.getItem('Email'),
          'distinct_id': localStorage.getItem('Email'),
        })
        localStorage.clear()
        await Auth.signOut().then((result) => {
          // localStorage.clear();
          navigate('/login')
        })
      } catch (error) {
        console.log('error'); 
      }
  }


  const handleClick = () => {
    document.body.classList.toggle('expandSideMenu');
  };


  // const subMenuClick = () => {
  //   document.body.classList.toggle('expandSubMenu');
  // }

  const [show, setShow] = useState<boolean>(false);

  return (
    <aside className={classnames(Styles.sideMenu, "sideMenu")}>
      {logoutModal && <ConfirmationModal logout={true} submit={onLogout} onClose={() => setLogoutModal(false)} />}
      <div className={Styles.sideMenuWrap}>
        <div className={classnames(Styles.header, "header")}>
          <img src={ellowLogo} className={classnames(Styles.logo, "logo")} alt="ellow.io" />
          <img src={ellowLogoIcon} className={classnames(Styles.icon, "icon")} alt="ellow.io" />
          <button onClick={handleClick}><Icon icon="ep:arrow-right-bold" /></button>
        </div>
        <div className={classnames(Styles.userInfo, "userInfo")}>
          <figure>
            {fullname && fullname.split(' ')[0][0] + fullname.split(' ')[1][0]}
          </figure>
          <figcaption>{fullname}</figcaption>
          <div className={Styles.role}>Recruiter</div>
        </div>
        <nav>
          {menu.map((item, key) =>
            <div key={key} className={`subMenu ${show ? "active" : ""}`}>
              <Link to={item.url} onClick={item.title === 'Resources' || item.title === 'Timesheet & Payment' ? () => { setShow((prev) => !prev); }
                : undefined} className={item.active ? classnames(Styles.active, show ? "activeLink" : '') : " "}><Icon icon={item.icon} />
                <span>
                  {item.title}
                  {item.title === 'Resources' && <Icon icon="ep:arrow-down-bold" />}
                  {item.title === 'Timesheet & Payment' && <Icon icon="ep:arrow-down-bold" />}
                </span></Link>
              {item.title === 'Resources' && show && item.active && <div className={classnames(Styles.subLinks, "subLinks")}>
                <Link to='/resources' className={openresource === 'allresources' ? "active" : ""}><span>All</span></Link>
                <Link to='/incontract' className={openresource === 'incontract' ? "active" : ""}><span>In Contract</span></Link>
                <Link to='/myworkplaceusers' className={openresource === 'myWorkplaceUsers' ? "active" : ""}><span>MyWorkPlace Users</span></Link>
                <Link to='/rejected' className={openresource === 'rejected' ? "active" : ""}><span>Rejected</span></Link>
                <Link to='/blacklisted' className={openresource === 'blacklisted' ? "active" : ""}><span>Blacklisted</span></Link>
                <Link to="/publicdatabase" className={openresource === "publicdatabase" ? "active" : ""}><span>Public Database</span></Link>
                <Link to="/crresource" className={openresource === "crresource" ? "active" : ""}><span>CR resources</span></Link>
                <Link to="/referedcandidates" className={openresource === "referedcandidates" ? "active" : ""}><span>Refered Candidates</span></Link>
              </div>}
              {item.title === 'Timesheet & Payment' && show && item.active && <div className={classnames(Styles.subLinks, "subLinks")}>
                <Link to='/candidatetimesheets' className={opentimesheet === 'candidateTimesheets' ? "active" : ""}><span>Candidate Timesheets</span></Link>
                <Link to='/companytimesheets' className={opentimesheet === 'companyTimesheets' ? "active" : ""}><span>Companywise Timesheets</span></Link>
                <Link to='/reports' className={opentimesheet === 'reports' ? "active" : ""}><span>Reports</span></Link>
              </div>}

            </div>
          )
          }

        </nav>


        <div className={Styles.referBtn}>
          {/* <Button onClick={[]} variant="primary"><Icon icon="bx:gift" />Refer & Earn</Button> */}
        </div>
      </div>
      <nav>
        <Link to={''} onClick={logout}>
          <Icon icon="ic:twotone-logout" />
          <span>Logout</span>
        </Link>
      </nav>
    </aside>
  );
}

export default SideMenu;
